import { useEffect, useState } from 'react';

const Security = () => {
  const [visibleItems, setVisibleItems] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const itemIndex = parseInt(entry.target.getAttribute('data-index') || '0');
            setVisibleItems(prev => [...prev, itemIndex]);
          }
        });
      },
      { threshold: 0.15 }
    );

    const items = document.querySelectorAll('.security-item');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const securityFeatures = [
    {
      title: 'Dados Protegidos',
      description: 'Mesma tecnologia usada por bancos',
    },
    {
      title: 'Privacidade Garantida',
      description: 'Seguimos leis de proteção de dados',
    },
    {
      title: 'Sempre Disponível',
      description: 'Sistema 24 horas por dia',
    },
    {
      title: 'Controle Total',
      description: 'Você vê tudo que acontece',
    }
  ];

  return (
    <section className="pt-0 md:pt-24 pb-24 px-4 sm:px-6 lg:px-8 bg-[#0d1117] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/5 w-80 h-80 bg-cyan-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/5 w-80 h-80 bg-indigo-600 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-cyan-400 uppercase tracking-wider" style={{ fontFamily: 'Inter, sans-serif' }}>Segurança</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Seus Dados em Mãos Seguras
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Segurança empresarial, simples de usar
          </p>
        </div>

        {/* Security Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {securityFeatures.map((feature, index) => (
            <div
              key={index}
              data-index={index}
              className={`security-item text-center p-8 rounded-xl bg-slate-900/80 backdrop-blur-sm border border-slate-800 hover:border-cyan-500/50 hover:shadow-2xl hover:shadow-cyan-500/10 transition-all duration-500 ${
                visibleItems.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${index * 100}ms`, fontFamily: 'Inter, sans-serif' }}
            >
              <h3 className="text-lg font-bold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Security;
